import Settings04 from "@uui/Settings04";

import useFilteredUpcomingEvents from "@app/analytics/Calendar/hooks/useFilteredUpcomingEvents";
import { HeaderButton } from "@app/analytics/Calendar/styles";
import { TabContentContainer } from "@app/analytics/Calendar/styles";
import TablePaginator from "@app/analytics/components/TablePaginator";
import useEventGroups from "@app/analytics/hooks/calendar/useEventGroups";
import type { UserEventGroup } from "@app/analytics/types/eventGroupTypes";
import usePagination from "@app/common/hooks/usePagination";
import ROUTES from "@app/common/routes";
import { usePageTitle } from "@app/utils/hooks";

import { Link } from "@rui/Link";
import { Row } from "@rui/Stack";
import { DesktopOnlyRow } from "@rui/Stack";

import UpcomingEventsFilterMenu from "./UpcomingEventsFilterMenu";
import UpcomingEventsTable from "./UpcomingEventsTable";
import VideoConferencingDropdown from "./VideoConferencingDropdown";

const FIVE_MINUTES = 5 * 60 * 1000;

const UpcomingEvents = () => {
  usePageTitle("Calendar");

  const { events, isLoading } = useEventGroups({
    refetchInterval: FIVE_MINUTES,
  });

  const filteredEvents = useFilteredUpcomingEvents(events);

  const pagination = usePagination<UserEventGroup>(filteredEvents, {
    loading: isLoading,
    resetScrollOnPageChange: true,
  });

  return (
    <TabContentContainer>
      <Row
        variant="apart"
        spacing={1}
        sx={{ mb: 2, minHeight: "44px", width: "100%" }}
      >
        <Row
          spacing={1}
          sx={{
            justifyContent: { xxs: "space-between", md: "flex-end" },
            width: { xxs: "100%", sm: "auto" },
          }}
        >
          <UpcomingEventsFilterMenu />
          <VideoConferencingDropdown />
        </Row>
        <DesktopOnlyRow spacing={1}>
          <Link to={ROUTES.USER_SETTINGS_INTEGRATIONS}>
            <HeaderButton
              startIcon={<Settings04 sx={{ color: "shades.neutral.500" }} />}
            >
              <span className="header-button__label">Settings</span>
            </HeaderButton>
          </Link>
          <TablePaginator height={40} loading={isLoading} {...pagination} />
        </DesktopOnlyRow>
      </Row>
      <UpcomingEventsTable events={filteredEvents} pagination={pagination} />
      <Row variant="right" sx={{ mt: 2 }}>
        <TablePaginator
          loading={isLoading}
          {...pagination}
          showPageSizeSelector
        />
      </Row>
    </TabContentContainer>
  );
};

export default UpcomingEvents;
